/* ag-attach.js - the ATTACH COORDINATOR (marker `agat`): the ONE place that extends the
   theme's own ADD TO CART request and the ONE writer of the main button's price span, shared
   by every attach card under the buy box: the chair card (assets/agcp.js) and the set card
   (assets/ag-set-attach.js). Plan set-attach v1.2 C3 / ruling R3 (Datch 2026-09-30): two
   cards each wrapping fetch and each re-applying its own text to `.agcf-atc-sub` would read
   the other's write as the theme's and sum twice or loop, so no card touches either any
   more; they register here.

   A card registers { id, on(), items(), total(), titles(), carry, refused(desc) }:
     on()        the card is ticked and able to add
     items()     [{id, quantity, handle?, surcharge?}] to append to the theme's items
                 array; surcharge {id, units} = the piece's own custom-finishing
                 surcharge line when the combo is carried (Datch 2026-10-13: a piece
                 in the page's combo pays the rate its own page charges)
     total()     cents to add to the main button's price while on()
     titles()    the product titles it adds, to attribute a 422 refusal
     carry       true = copy the main item's line properties (a custom-finishing combo,
                 agcf.js) onto its items, so the piece is finished like the main product;
                 the page's preview render (_preview) is not copied, it pictures the
                 page's product
     refused()   Shopify refused its item (sold out since the page rendered): the card
                 shows that itself
   Registration is order-free: a card that loads before this file pushes onto
   window.AGAttachQ and is picked up here; after this file, pushes register at once.

   1. THE ADD (the chair card's R7 mechanics, unchanged for clients): a press on the main
      ADD TO CART, or a submit of its form, ARMS the extension while any card is on(); the
      next POST /cart/add.js whose items carry the page's current variant
      (#product-variant-id) gains every on() card's items. One request; the theme's own
      post-add sequence (drawer refreshCart() then open(), the count nodes) runs once and
      shows every line. Nothing on() = nothing armed, the body passes untouched. On a 422
      the theme's own body is posted once more; when that goes through, the refusal is
      attributed by product title (Shopify names it in the description) to the card it
      names, every card when it names none, and that card's refused() runs. When the main
      product is refused too, the theme sees that refusal exactly as it would have.
   2. THE PRICE: the theme writes `.agcf-atc-sub` (product-hero.js mirrors
      #product-main-price on products without agcf.js; agcf.js updateAtcPrice() on
      customizable ones). This file records the theme's own last text (any text that is not
      its own write) and writes theme text + the sum of on() cards' total(), re-applied
      after every theme write (a MutationObserver on the span; its own write is recognised
      by text and its records are taken, so it never loops) and after the page's quantity
      moves. Nothing on() = the theme's text, put back untouched.
   agcf.js a8CartShim (the custom-finish surcharge line) stays as it is: it wraps fetch
   before this file does, so it still sees the extended array exactly as it saw the chair.
   No navigation, no reload, no dependency. */
(function () {
  "use strict";
  if (window.AGAttach) return;

  var ARM_MS = 15000;
  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/;
  var cards = [];
  var addedCbs = [];
  var armedAt = 0;
  var themeText = null;
  var lastWrite = null;
  var mo = null;
  var watched = null;

  function mainBtn() { return document.getElementById("add-to-cart-btn"); }
  function mainForm() { var b = mainBtn(); return b && b.closest ? b.closest("form") : null; }
  function mainSub() { var b = mainBtn(); return b ? b.querySelector(".agcf-atc-sub") : null; }
  function mainQtyInput() {
    var f = mainForm();
    return (f && f.querySelector("#quantity")) || document.getElementById("quantity");
  }
  function mainVariant() {
    var f = mainForm();
    var i = (f && f.querySelector("#product-variant-id")) || document.getElementById("product-variant-id");
    return i ? String(i.value || i.getAttribute("data-variant-id") || "") : "";
  }

  /* "$3,450" / "$1,351.50" <-> cents, the currency prefix/suffix kept */
  function parse(txt) {
    var m = /^(\D*?)(\d[\d,]*)(?:\.(\d{1,2}))?(\D*)$/.exec((txt || "").trim());
    if (!m) return null;
    var c = parseInt(m[2].replace(/,/g, ""), 10) * 100 + (m[3] ? parseInt((m[3] + "0").slice(0, 2), 10) : 0);
    return isNaN(c) ? null : { cents: c, tpl: [m[1], m[4]] };
  }
  function money(cents, tpl) {
    var whole = Math.floor(cents / 100);
    var rest = cents % 100;
    var s = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (rest) s += "." + (rest < 10 ? "0" : "") + rest;
    return tpl[0] + s + tpl[1];
  }

  function onCards() {
    var out = [];
    for (var i = 0; i < cards.length; i++) {
      try { if (cards[i].on()) out.push(cards[i]); } catch (e) { /* a broken card never blocks the add */ }
    }
    return out;
  }

  /* ---------- the price ---------- */
  function watch(sub) {
    if (!window.MutationObserver || sub === watched) return;
    if (mo) mo.disconnect();
    mo = new MutationObserver(applyMain);
    mo.observe(sub, { childList: true, characterData: true, subtree: true });
    watched = sub;
  }
  function applyMain() {
    var sub = mainSub();
    if (!sub) return;
    watch(sub);
    var cur = sub.textContent.trim();
    if (themeText === null || cur !== lastWrite) themeText = cur;
    var txt = themeText;
    var list = onCards();
    if (list.length) {
      var base = parse(themeText);
      var add = 0;
      for (var i = 0; i < list.length; i++) {
        var t = 0;
        try { t = parseInt(list[i].total(), 10) || 0; } catch (e) { t = 0; }
        add += t;
      }
      if (base && add > 0) txt = money(base.cents + add, base.tpl);
    }
    if (cur !== txt) sub.textContent = txt;
    lastWrite = txt;
    if (mo) mo.takeRecords();
  }
  function soon() {
    applyMain();
    setTimeout(applyMain, 0);
    setTimeout(applyMain, 60);
    setTimeout(applyMain, 300);
  }

  /* ---------- the add ---------- */
  function arm() { armedAt = onCards().length ? Date.now() : 0; }

  function cloneProps(p) {
    var out = {};
    for (var k in p) if (Object.prototype.hasOwnProperty.call(p, k) && k !== "_preview") out[k] = p[k];
    return out;
  }

  function extend(input, init) {
    if (!armedAt || Date.now() - armedAt > ARM_MS) return null;
    if (!init || typeof init.body !== "string") return null;
    if (String(init.method || "GET").toUpperCase() !== "POST") return null;
    var url = typeof input === "string" ? input : String((input && input.url) || "");
    if (!ADD_RE.test(url)) return null;
    var list = onCards();
    if (!list.length) return null;
    var main = mainVariant();
    var data = JSON.parse(init.body);
    if (!main || !data || !data.items || !data.items.length) return null;
    var mainItem = null;
    var have = {};
    for (var i = 0; i < data.items.length; i++) {
      var it = data.items[i];
      if (!it) continue;
      have[String(it.id)] = true;
      if (String(it.id) === main) mainItem = it;
    }
    if (!mainItem) return null;
    var used = [];
    for (var c = 0; c < list.length; c++) {
      var items = [];
      try { items = list[c].items() || []; } catch (e) { items = []; }
      var took = false;
      for (var j = 0; j < items.length; j++) {
        var item = items[j];
        if (!item || !item.id || have[String(item.id)]) continue;
        var copy = { id: item.id, quantity: item.quantity > 0 ? item.quantity : 1 };
        if (item.properties) copy.properties = item.properties;
        else if (list[c].carry && mainItem.properties) copy.properties = cloneProps(mainItem.properties);
        data.items.push(copy);
        have[String(item.id)] = true;
        took = true;
        /* the carried combo's own surcharge line (agcf's shim prices the page's item only): the card supplies the
           units, the codes are the carried ones, and _for_product names the piece so agcf pairs each line with its own */
        var codes = copy.properties && copy.properties._finish_codes;
        var sur = item.surcharge;
        if (codes && sur && sur.id && sur.units > 0) {
          data.items.push({ id: sur.id, quantity: sur.units * copy.quantity,
            properties: { _surcharge_for: codes, _for_product: item.handle || "", _units_per_item: String(sur.units) } });
        }
      }
      if (took) used.push(list[c]);
    }
    if (!used.length) return null;
    var out = {};
    for (var k in init) if (Object.prototype.hasOwnProperty.call(init, k)) out[k] = init[k];
    out.body = JSON.stringify(data);
    return { init: out, items: data.items, cards: used };
  }

  /* a 422 on the extended body, the theme's own body accepted: name the card */
  function attribute(used, desc) {
    var d = String(desc || "").toLowerCase();
    var hit = [];
    for (var i = 0; i < used.length; i++) {
      var titles = [];
      try { titles = used[i].titles() || []; } catch (e) { titles = []; }
      for (var j = 0; j < titles.length; j++) {
        var t = String(titles[j] || "").toLowerCase().replace(/\s+/g, " ").trim();
        if (t && d.indexOf(t) >= 0) { hit.push(used[i]); break; }
      }
    }
    if (!hit.length) hit = used;
    for (var k = 0; k < hit.length; k++) {
      try { hit[k].refused(desc); } catch (e) { /* the card's own problem */ }
    }
    if (window.console) console.warn("ag-attach: an attached item was refused (422); the page's item was added alone", desc || "");
    soon();
  }

  function notifyAdded(ext) {
    for (var i = 0; i < addedCbs.length; i++) {
      try { addedCbs[i](ext.items, ext.cards); } catch (e) { /* listeners never break the add */ }
    }
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === "function") {
    window.fetch = function (input, init) {
      var ext = null;
      try { ext = extend(input, init); } catch (e) { ext = null; }
      if (!ext) return nativeFetch.apply(window, arguments);
      armedAt = 0;
      return nativeFetch.call(window, input, ext.init).then(function (res) {
        if (res.ok) {
          window.AG_ATTACH_LAST_ADD = { items: ext.items, at: Date.now() };
          notifyAdded(ext);
          return res;
        }
        if (res.status !== 422) return res;
        return res.clone().json().then(function (err) { return err; }, function () { return {}; }).then(function (err) {
          return nativeFetch.call(window, input, init).then(function (alone) {
            if (alone.ok) attribute(ext.cards, err && err.description);
            return alone;
          });
        });
      });
    };
  }

  /* ---------- events, all on window in the capture phase ---------- */
  window.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var f = mainForm();
    if (f && f.contains(t)) {
      if (t.closest(".qty-minus, .qty-plus")) soon();
      var b = mainBtn();
      if (b && b.contains(t)) arm();
    }
  }, true);
  window.addEventListener("submit", function (e) {
    var f = mainForm();
    if (f && e.target === f) arm();
  }, true);
  function onType(e) {
    var t = e.target;
    if (!t) return;
    if (t === mainQtyInput() || t.id === "product-variant-id") soon();
  }
  window.addEventListener("input", onType, true);
  window.addEventListener("change", onType, true);
  window.addEventListener("pageshow", applyMain);

  /* ---------- the registry ---------- */
  function register(card) {
    if (!card || typeof card.on !== "function") return null;
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].id === card.id) { cards[i] = card; applyMain(); return api; }
    }
    cards.push(card);
    applyMain();
    return api;
  }
  var api = {
    register: register,
    refresh: soon,
    /* the theme's own price text as cents (null until the span exists); a card whose figure must REPLACE
       the theme's (the set card in priced mode) returns total() = its exact figure minus this */
    base: function () {
      if (themeText === null) applyMain();
      var p = parse(themeText);
      return p ? p.cents : null;
    },
    onAdded: function (cb) { if (typeof cb === "function") addedCbs.push(cb); },
    state: function () {
      var sub = mainSub();
      var on = onCards();
      var ids = [];
      for (var i = 0; i < on.length; i++) ids.push(on[i].id);
      return { cards: cards.length, on: ids, main: sub ? sub.textContent : null, theme: themeText, armed: !!armedAt };
    }
  };
  window.AGAttach = api;

  /* cards that loaded first */
  var q = window.AGAttachQ;
  if (q && q.length) for (var qi = 0; qi < q.length; qi++) register(q[qi]);
  window.AGAttachQ = { push: function (card) { register(card); return 1; }, length: 0 };

  applyMain();
})();
